import { toast } from 'sonner'

export function showSuccessData(
  title: string,
  data?: unknown,
) {
  toast.success(title, {
    description: (
      // w-[340px]
      <span>{JSON.stringify(data)}</span>
    ),
  })
}

export function showErrorData(
  title: string,
  data?: unknown,
) {
  toast.error(title, {
    description: (
      // w-[340px]
      <span>{JSON.stringify(data)}</span>
    ),
  })
}
